import React, { useState, useEffect } from "react";
import axios from "axios";
import PopUp from "../../components/PopUp";
import { FaTimesCircle } from "react-icons/fa";
import { InfoBlock, RectBtn } from "../../components/General";
import FormControl from "@mui/material/FormControl";
import { Input, InputLabel } from "@mui/material";

const ConfigThreshold = ({ switchOn, setSwitchOn }) => {
    const WEB_URL = process.env.REACT_APP_WEB_SERVER_URL;
    const [ammoniaThreshold, setAmmoniaThreshold] = useState("");
    const [ammoniaThresholdInput, setAmmoniaThresholdInput] = useState("");

    const handleUpdateAmmoniaThreshold = async () => {
        try {
            const res = await axios.patch(`${WEB_URL}/setAmmoniaThreshold`, {
                threshold: ammoniaThresholdInput,
            });

            if (res.data.indicator) {
                console.log(res.data);
                setAmmoniaThreshold(res.data.message);
                setAmmoniaThresholdInput(res.data.message);
            } else {
                console.log(res.data.message);
            }
        } catch (err) {
            console.log(err);
        }
    };

    useEffect(() => {
        if (switchOn) {
            axios
                .get(`${WEB_URL}/globalStatus`)
                .then((res) => {
                    if (res.data.indicator) {
                        setAmmoniaThreshold(res.data.message.ammonia_threshold);
                        setAmmoniaThresholdInput(res.data.message.ammonia_threshold);
                    } else {
                        console.log(res.data.message);
                    }
                })
                .catch((err) => {
                    console.log(err);
                });
        } else {
            setAmmoniaThreshold("");
            setAmmoniaThresholdInput("");
        }
    }, [switchOn]);
    return (
        <PopUp width={60} height={60} switchOn={switchOn}>
            <div className="pop-up-content-wrapper">
                <div className="pop-up-row">
                    <h4>Threshold Configs</h4>
                    <FaTimesCircle
                        className="pop-up-close-btn"
                        onClick={() => {
                            setSwitchOn(null);
                        }}
                    />
                </div>
                <div className="pop-up-division-line"></div>
                <div className="pop-up-body">
                    <div className="pop-up-row -wrap info-block-row">
                        <InfoBlock
                            title={"Ammonia Threshold"}
                            headerExtension={
                                <>
                                    <FormControl>
                                        <InputLabel htmlFor="ammonia-threshold-input">Current Threshold</InputLabel>
                                        <Input
                                            id="ammonia-threshold-input"
                                            type="number"
                                            value={ammoniaThreshold}
                                            disabled
                                            onChange={(event) => setAmmoniaThreshold(event.target.value)}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <InputLabel htmlFor="ammonia-threshold-input">New Threshold</InputLabel>
                                        <Input
                                            id="ammonia-threshold-input"
                                            type="number"
                                            value={ammoniaThresholdInput}
                                            onChange={(event) => setAmmoniaThresholdInput(event.target.value)}
                                        />
                                    </FormControl>
                                    <FormControl>
                                        <RectBtn onClick={handleUpdateAmmoniaThreshold}>Update</RectBtn>
                                    </FormControl>
                                </>
                            }
                        />
                    </div>
                </div>
            </div>
        </PopUp>
    );
};

export default ConfigThreshold;
